import { Injectable } from "@angular/core";
import { CRMActivityConnector } from "./crm-activity.connector";
import { AppServerCRMActivityConnector } from "../../app-server-connectors";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { ActivityDocument, ActivityType, APIResponse, EntityType, FilterQuery } from "server-model";

@Injectable()
export class CRMActivityDataService {
    private crmActivityConnector: CRMActivityConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.crmActivityConnector = new AppServerCRMActivityConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getActivity(activityId: string, organisationId: string): Promise<APIResponse> {
        const response = await this.crmActivityConnector.getActivity(activityId, organisationId);
        return response;
    }

    async listActivity(organisationId: string, entityType: EntityType, entityId: string, filterQuery: FilterQuery): Promise<APIResponse> {
        const response = await this.crmActivityConnector.listActivity(organisationId, entityType, entityId, filterQuery);
        return response;
    }

    async createActivity(activityDocument: ActivityDocument): Promise<APIResponse> {
        const response = await this.crmActivityConnector.createActivity(activityDocument);
        return response;
    }

    async deleteActivity(activityId: string, organisationId: string): Promise<APIResponse> {
        const response = await this.crmActivityConnector.deleteActivity(activityId, organisationId);
        return response;
    }

    async updateActivity(activityId: string, organisationId: string, activityDocument: Partial<ActivityDocument>): Promise<APIResponse> {
        const response = await this.crmActivityConnector.updateActivity(activityId, organisationId, activityDocument);
        return response;
    }

    async getAllActivitySpecificType(organisationId: string, activityType: ActivityType | string, filterQuery: FilterQuery): Promise<APIResponse> {
        const response = await this.crmActivityConnector.getAllActivitySpecificType(organisationId, activityType, filterQuery);
        return response;
    }

    async getAllActivitySpecificTypeSpecificEntity(organisationId: string, entityType: EntityType, entityId: string, activityType: ActivityType | string, filterQuery: FilterQuery): Promise<APIResponse> {
        const response = await this.crmActivityConnector.getAllActivitySpecificTypeSpecificEntity(organisationId, entityType, entityId, activityType, filterQuery);
        return response;
    }
}
